/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";

const FeedbackComponentDisplay = () => {
    
    const { t } = useTranslation();
    const { component } = useContext(ContentZoneContext);
    const { primary_question = "" } = component;
    const hasContent = primary_question && primary_question.length > 0;

    return (
        <>
            {!hasContent ? <EmptyContentMessage hasContent={hasContent} component={component} /> : null}
            {hasContent && (
                <div className='page-feedback__block' style={{ display: "flex", justifyContent: "center" }}>
                    <div
                        className='page-feedback__header'
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <h2 className='page-feedback__title'>{primary_question}</h2>
                        <div
                            className='page-feedback__options'
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                gap: "0.6rem",
                            }}
                        >
                            <Button color='primary' variant='contained'>
                                {t("commons.yes")}
                            </Button>
                            <Button color='primary' variant='contained'>
                                {t("commons.no")}
                            </Button>
                        </div>
                    </div>
                    <div className='page-feedback__form'>
                        {/*<button className="page-feedback__close" aria-expanded="true" aria-label="Close the feedback form">*/}
                        {/*    Close*/}
                        {/*</button>*/}
                        <div className='region region-page-feedback'>
                            <div id='block-webform-client-block-2784' className='block block-webform'>
                                <div className='content'>
                                    {/*<form */}
                                    {/*    className="webform-client-form webform-client-form-2784 webform-conditional-processed" */}
                                    {/*    action="/parks-trails-recreation/deep-cove-designated-anchorage-area"*/}
                                    {/*    method="post" */}
                                    {/*    id="webform-client-form-2784"*/}
                                    {/*    acceptCharset="UTF-8"*/}
                                    {/*>*/}
                                    {/*    <div>*/}
                                    {/*        <div className="webform-progressbar"></div>*/}
                                    {/*        <div className="page-feedback__hidden form-item webform-component webform-component-textfield webform-component--page-url">*/}
                                    {/*            <label className="element-invisible" htmlFor="edit-submitted-page-url">*/}
                                    {/*                Page url*/}
                                    {/*            </label>*/}
                                    {/*            <input readOnly="readonly" type="text" id="edit-submitted-page-url" name="submitted[page_url]" value="" size="60" maxLength="128" className="form-text" />*/}
                                    {/*        </div>*/}
                                    {/*        <div className="page-feedback__helpful page-feedback__hidden form-item webform-component webform-component-radios webform-component--helpful">*/}
                                    {/*            <label className="element-invisible" htmlFor="edit-submitted-helpful">*/}
                                    {/*                Helpful*/}
                                    {/*            </label>*/}
                                    {/*            <div id="edit-submitted-helpful" className="form-radios">*/}
                                    {/*                <div className="form-item form-type-radio form-item-submitted-helpful">*/}
                                    {/*                    /!*<input type="radio" id="edit-submitted-helpful-1" name="submitted[helpful]" value="yes" className="form-radio" />*!/*/}
                                    {/*                    <label className="option" htmlFor="edit-submitted-helpful-1">*/}
                                    {/*                        Yes*/}
                                    {/*                    </label>*/}
                                    {/*                </div>*/}
                                    {/*                <div className="form-item form-type-radio form-item-submitted-helpful">*/}
                                    {/*                    /!*<input type="radio" id="edit-submitted-helpful-2" name="submitted[helpful]" value="no" className="form-radio" />*!/*/}
                                    {/*                    <label className="option" htmlFor="edit-submitted-helpful-2">*/}
                                    {/*                        No*/}
                                    {/*                    </label>*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="page-feedback__feedback form-item webform-component webform-component-textarea webform-component--thanks-for-your-input-how-could-it-be-improved-optional webform-conditional-hidden" style={{display: 'none'}}>*/}
                                    {/*            <label htmlFor="edit-submitted-thanks-for-your-input-how-could-it-be-improved-optional">Thanks for your input. How could it be improved? (Optional) </label>*/}
                                    {/*            <div className="form-textarea-wrapper resizable textarea-processed resizable-textarea">*/}
                                    {/*                <textarea*/}
                                    {/*                    id="edit-submitted-thanks-for-your-input-how-could-it-be-improved-optional"*/}
                                    {/*                    name="submitted[thanks_for_your_input_how_could_it_be_improved_optional]"*/}
                                    {/*                    cols="60" rows="5"*/}
                                    {/*                    className="form-textarea webform-conditional-disabled"*/}
                                    {/*                    disabled=""></textarea>*/}
                                    {/*                <div className="grippie"></div>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="wysiwyg">*/}
                                    {/*            <div className="form-item webform-component webform-component-markup webform-component--thanks-for-your-input webform-conditional-hidden" style={{display: 'none'}}>*/}
                                    {/*                <p>Thanks for your input.</p>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*        <input type="hidden" name="details[sid]" />*/}
                                    {/*        <input type="hidden" name="details[page_num]" value="1" />*/}
                                    {/*        <input type="hidden" name="details[page_count]" value="1" />*/}
                                    {/*        <input type="hidden" name="details[finished]" value="0" />*/}
                                    {/*        <input type="hidden" name="form_build_id" value="form-4SwBM13EylihnUK8Fq9nTTjI4qYMxGoVBWIGaxWCqXE" />*/}
                                    {/*        <input type="hidden" name="form_id" value="webform_client_form_2784" />*/}
                                    {/*        <input type="hidden" name="honeypot_time" value="1661882142|vSitoFgT-mUXKcjNhUeD7F5_9_Y5GBjCb3BDKR-B22s" />*/}
                                    {/*        <div className="url-textfield">*/}
                                    {/*            <div className="form-item form-type-textfield form-item-url">*/}
                                    {/*                <label htmlFor="edit-url">Leave this field blank </label>*/}
                                    {/*                <input autoComplete="off" type="text" id="edit-url" name="url" value="" size="20" maxLength="128" className="form-text" />*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="form-actions">*/}
                                    {/*            <input className="webform-submit button-primary form-submit" type="submit" name="op" value="Submit" />*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*</form>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

FeedbackComponentDisplay.displayName = "FeedbackComponentDisplay";
export { FeedbackComponentDisplay };
